import { Link } from "react-router-dom";

export default function Destinations() {
  const countries = [
    {
      flag: "🇭🇺",
      name: "Hungary",
      description:
        "The long-established dental tourism capital of Europe. Particularly strong for implants and full-arch restorations. EU-regulated, typically requires two trips.",
      tags: ["Implants", "Full Arch", "Long-term Focus"],
      image:
        "https://readdy.ai/api/search-image?query=Budapest%20Hungary%20Parliament%20building%20illuminated%20at%20dusk%20with%20Danube%20river%20reflection%2C%20stunning%20European%20architecture%2C%20warm%20golden%20hour%20lighting%2C%20travel%20photography%2C%20cityscape&width=400&height=180&seq=dsa-hu-001&orientation=landscape",
      alt: "Budapest skyline with the Parliament building",
    },
    {
      flag: "🇹🇷",
      name: "Turkey",
      description:
        "The most price-competitive destination, popular for cosmetic dentistry — especially veneers. High volume, fast turnaround. Quality varies; research essential.",
      tags: ["Veneers", "Cosmetic", "Budget-led"],
      image:
        "https://readdy.ai/api/search-image?query=Istanbul%20Turkey%20Blue%20Mosque%20and%20Hagia%20Sophia%20at%20beautiful%20sunset%2C%20Bosphorus%20strait%20view%2C%20stunning%20Turkish%20architecture%2C%20warm%20ambient%20lighting%2C%20travel%20destination%20photography&width=400&height=180&seq=dsa-tr-001&orientation=landscape",
      alt: "Istanbul cityscape",
    },
    {
      flag: "🇵🇱",
      name: "Poland",
      description:
        "A strong all-rounder: EU standards, transparent pricing, shorter travel from the UK, and a growing reputation for quality across a broad range of treatments.",
      tags: ["Crowns & Bridges", "EU Standards", "Balanced"],
      image:
        "https://readdy.ai/api/search-image?query=Warsaw%20Poland%20colorful%20old%20town%20market%20square%20with%20historic%20buildings%2C%20charming%20European%20cityscape%2C%20warm%20daylight%20photography%2C%20travel%20destination%2C%20beautiful%20architecture&width=400&height=180&seq=dsa-pl-001&orientation=landscape",
      alt: "Warsaw city centre",
    },
    {
      flag: "🇪🇸",
      name: "Spain",
      badge: "Premium EU",
      description:
        "Premium EU-regulated care with the easiest travel from the UK. Best for patients who want strong aftercare access — return flights are just 2–3 hours away.",
      tags: ["EU-regulated", "Easy Travel", "Strong Aftercare"],
      image:
        "https://readdy.ai/api/search-image?query=Barcelona%20Spain%20Sagrada%20Familia%20cathedral%20with%20cityscape%20view%2C%20Gaudi%20masterpiece%20architecture%2C%20warm%20golden%20light%2C%20travel%20photography%2C%20beautiful%20Spanish%20destination&width=400&height=180&seq=dsa-es-001&orientation=landscape",
      alt: "Barcelona cityscape with Sagrada Familia",
    },
  ];

  return (
    <section className="bg-background-50 py-16 md:py-20 lg:py-24" id="destinations">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-3 block">
            Destination Overview
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Hungary, Poland, Turkey or Spain?
          </h2>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-10 max-w-3xl">
            Each destination has a distinct profile. Here&apos;s a quick snapshot — our{" "}
            <Link
              to="/country-fit"
              className="text-primary-600 hover:text-primary-700 underline underline-offset-2"
            >
              Country Fit
            </Link>{" "}
            page has the full comparison.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-10">
            {countries.map((country) => (
              <article
                key={country.name}
                className="bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300/60 transition-colors"
              >
                <div className="w-full h-40 overflow-hidden">
                  <img
                    src={country.image}
                    alt={country.alt}
                    width={400}
                    height={180}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xl">{country.flag}</span>
                    <h3 className="text-base md:text-lg font-semibold text-foreground-950">
                      {country.name}
                    </h3>
                    {country.badge && (
                      <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
                        {country.badge}
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    {country.description}
                  </p>
                  <div className="flex flex-wrap gap-1.5">
                    {country.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2.5 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/country-fit"
              className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium rounded-md border border-foreground-400/30 text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              View Full Comparison
              <span className="w-4 h-4 flex items-center justify-center ml-1.5">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}